import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { NotificationsNotFoundComponent } from './notifications-not-found.component';

@NgModule({
	declarations: [NotificationsNotFoundComponent],
	exports: [NotificationsNotFoundComponent],
	providers: [],
	imports: [CommonModule, TranslateModule, FreudTypographyModule],
})
export class NotificationsNotFoundModule {}
